module.exports = __webpack_public_path__ + "static/media/four-card.137cb31d.jpg";